import { WSQueryConfig } from "@ws-react-query";
import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";

import { useWSQuery } from "../../helpers";
import { QUERY_REQUIREMENT_DEFINITION } from "../keys";
import { getRequirementDefinition } from "../../../services/requirementDefinitions/getRequirementDefinition";

export const useRequirementDefinitionQuery = (
  id: string,
  queryConfig?: WSQueryConfig<IRequirementDefinitionResponse, unknown>
) =>
  useWSQuery(
    [QUERY_REQUIREMENT_DEFINITION, id],
    () => getRequirementDefinition(id),
    {
      retry: false,
      ...queryConfig
    }
  );
